import moment from "@/utils/moment";
import paramsHelper from "../helpers/params";
import addressMixin from "@/mixins/addressMixin";

function toSnakeCase(string) {
  return string.replace(/[A-Z]/g, char => `_${char.toLowerCase()}`);
}

function getDate(date) {
  return moment(date).startOf("day");
}

function getInitialHour(initialHour) {
  return moment()
    .startOf("day")
    .add(initialHour, "hours")
    .utc()
    .hours();
}

function formatDatetime(datetime) {
  return datetime.format("YYYY-MM-DD HH:mm:ss");
}

function buildQuery(filters, scheduleEventSearch = false) {
  if (filters.professionalName && !scheduleEventSearch) {
    return [
      {
        name: "professional_name",
        value: filters.professionalName
      }
    ];
  }

  return Object.keys(filters).reduce((query, filter) => {
    if (filters[filter]) {
      let value = filters[filter];

      if (filter === "date") {
        value = formatDatetime(getDate(filters[filter]));
      }

      if (filter === "initialHour") {
        value = getInitialHour(filters[filter]);
      }

      query.push({
        name: toSnakeCase(filter),
        value
      });
    }

    return query;
  }, []);
}

const buildAvailableProfessionalSearchQuery = (address, filters) => {
  return paramsHelper.buildParams({
    queries: [
      ...buildQuery(filters),
      { name: "district_id", value: addressMixin.methods.districtId(address) }
    ]
  });
};

const buildAvailableScheduleEventsSearchQuery = (
  professionalId,
  address,
  filters
) => {
  return paramsHelper.buildParams({
    queries: [
      ...buildQuery(filters, true),
      { name: "professional_id", value: professionalId },
      { name: "district_id", value: addressMixin.methods.districtId(address) }
    ]
  });
};

const buildCreateOrderBody = (user, state) => {
  const starts_at = moment(state.filters.date).hour(state.filters.initialHour);
  const ends_at = moment(state.filters.date)
    .hour(state.filters.initialHour)
    .add(state.filters.duration, "hours");

  return {
    data: {
      type: "orders",
      attributes: {
        starts_at: starts_at.toISOString(),
        ends_at: ends_at.toISOString(),
        description: state.description
      },
      relationships: {
        customer: {
          data: {
            type: user.accountable.type,
            id: user.accountable.id
          }
        },
        professional: {
          data: {
            type: "professionals",
            id: state.professionalId
          }
        },
        schedule_event: {
          data: {
            type: "schedule_events",
            id: state.scheduleEventId
          }
        },
        address: {
          data: {
            type: "addresses",
            id: state.selectedAddress
          }
        }
      }
    },
    use_pag_bank: true,
    should_include_products: state.shouldIncludeProducts
  };
};

const buildApplyOrderCouponBody = (professional, orderId) => {
  return {
    order: orderId,
    coupon: professional.active_coupon.id
  };
};

export default {
  buildAvailableProfessionalSearchQuery,
  buildAvailableScheduleEventsSearchQuery,
  buildCreateOrderBody,
  buildApplyOrderCouponBody
};



// WEBPACK FOOTER //
// ./src/api/helpers/apiOrderSchedulerHelper.js